// @flow

import type { Action } from './store.type';

type CampaignDetailFailure = {
  error: any
};

/* #region: Get campaign detail by id */
export const GET_CAMPAIGN_DETAIL_REQUEST = 'GET_CAMPAIGN_DETAIL_REQUEST';
type GET_CAMPAIGN_DETAIL_REQUEST_TYPE = 'GET_CAMPAIGN_DETAIL_REQUEST';

export const GET_CAMPAIGN_DETAIL_SUCCESS = 'GET_CAMPAIGN_DETAIL_SUCCESS';
type GET_CAMPAIGN_DETAIL_SUCCESS_TYPE = 'GET_CAMPAIGN_DETAIL_SUCCESS';

export const GET_CAMPAIGN_DETAIL_FAILURE = 'GET_CAMPAIGN_DETAIL_FAILURE';
type GET_CAMPAIGN_DETAIL_FAILURE_TYPE = 'GET_CAMPAIGN_DETAIL_FAILURE';

type GetCampaignDetailRequestAction = Action<GET_CAMPAIGN_DETAIL_REQUEST_TYPE, null>;

type GetCampaignDetailSuccessAction = Action<
  GET_CAMPAIGN_DETAIL_SUCCESS_TYPE,
  { data: Object }
>;

type GetCampaignDetailFailureAction = Action<
  GET_CAMPAIGN_DETAIL_FAILURE_TYPE,
  CampaignDetailFailure
>;
/* #endregion */

export const RESET_CAMPAIGN_DETAIL = 'RESET_CAMPAIGN_DETAIL';
type RESET_CAMPAIGN_DETAIL_TYPE = 'RESET_CAMPAIGN_DETAIL';

type ResetCampaignDetailAction = Action<RESET_CAMPAIGN_DETAIL_TYPE, null>;

export type CampaignPlannerAction =
  | GetCampaignDetailRequestAction
  | GetCampaignDetailSuccessAction
  | GetCampaignDetailFailureAction
  | ResetCampaignDetailAction;
